import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class MailerServiceProviderService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private providerUrl = this.baseApiUrl + '/api/v1/mailer-service-provider';

  getProviders(params: any = {}) {
    return this.http.get(`${this.providerUrl}`, {params});
  }

  getProvider(id: number) {
    return this.http.get(`${this.providerUrl}/${id}`);
  }

  createProvider(provider: any) {
    return this.http.post(`${this.providerUrl}`, provider);
  }

  updateProvider(id: number, provider: any) {
    return this.http.put(`${this.providerUrl}/${id}`, provider);
  }

  deleteProvider(id: number) {
    return this.http.delete(`${this.providerUrl}/${id}`);
  }

  setDefault(id: number) {
    return this.http.post(`${this.providerUrl}/${id}/set-default`, {});
  }

  getPluginConfigSchemas() {
    return this.http.get(`${this.providerUrl}/plugin-config-schemas`);
  }
}
